import { AlertDialog, AlertDialogCloseButton, AlertDialogContent, AlertDialogHeader, AlertDialogOverlay } from "@chakra-ui/react";

export default function Dialog({ title, children, loading = false, onClose = () => {}, ...props }){

    const onCloseDialog = () => loading ? null : onClose()

    return(
    <AlertDialog onClose={onCloseDialog} {...props}>
        <AlertDialogOverlay backdropFilter="blur(10px)" />
        <AlertDialogContent>
            <AlertDialogCloseButton isDisabled={loading} />
            <AlertDialogHeader fontSize="md" children={title} />
            { children }
        </AlertDialogContent>
    </AlertDialog>
    )
}